module.exports = __webpack_public_path__ + "img/sys5-select.91cdc164.png";